import React from 'react';
import { defineMessages } from 'react-intl';
import type { BlockSchemaProps } from '@plone/types';
import { defaultStylingSchema } from '../schema';

const messages = defineMessages({
  mainImageBlock: {
    id: 'Main Image Block',
    defaultMessage: 'Bloco de Imagem Principal',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Título',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Descrição',
  },
  altText: {
    id: 'Alt Text',
    defaultMessage: 'Descrição Alternativa',
  },
  AltTextHint: {
    id: 'Alt text hint',
    defaultMessage: 'Deixe em branco se a imagem for puramente decorativa',
  },
  AltTextHintLinkText: {
    id: 'Alt text hint link text',
    defaultMessage: 'Descreva o propósito da imagem',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Abrir em uma nova aba',
  },
  position: {
    id: 'Position',
    defaultMessage: 'Posição',
  },
  size: {
    id: 'Size',
    defaultMessage: 'Tamanho',
  },
  positionLeft: {
    id: 'Left',
    defaultMessage: 'Esquerda',
  },
  positionCenter: {
    id: 'Center',
    defaultMessage: 'Centro',
  },
  positionRight: {
    id: 'Right',
    defaultMessage: 'Direita',
  },
  sizeSmall: {
    id: 'Small',
    defaultMessage: 'Pequeno',
  },
  sizeMedium: {
    id: 'Medium',
    defaultMessage: 'Médio',
  },
  sizeLarge: {
    id: 'Large',
    defaultMessage: 'Grande',
  },
});

export const MainImageSchema = (props: BlockSchemaProps): any => {
  const { intl } = props;

  const description: React.ReactNode = (
    <>
      <a
        href="https://www.w3.org/WAI/tutorials/images/decision-tree/"
        title={intl.formatMessage(messages.openLinkInNewTab)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage(messages.AltTextHintLinkText)}
      </a>{' '}
      {intl.formatMessage(messages.AltTextHint)}
    </>
  );

  const schema: any = {
    title: intl.formatMessage(messages.mainImageBlock),
    fieldsets: [
      {
        id: 'default',
        title: 'default',
        fields: ['title', 'description', 'altText', 'position', 'size'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        type: 'string',
      },
      description: {
        title: intl.formatMessage(messages.description),
        type: 'string',
        widget: 'textarea',
      },
      altText: {
        title: intl.formatMessage(messages.altText),
        type: 'string',
        description: description,
      },
      position: {
        title: intl.formatMessage(messages.position),
        type: 'string',
        widget: 'align',
      },
      size: {
        title: intl.formatMessage(messages.size),
        type: 'string',
        widget: 'image_size',
        default: 'm',
      },
    },
    required: [],
  };

  try {
    return defaultStylingSchema({ schema, formData: props, intl });
  } catch (error) {
    return schema;
  }
};
